import React from 'react';
import {createRoot} from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as Sentry from '@sentry/react';

const {REACT_APP_GLITCHTIP_DSN} = process.env;

if (REACT_APP_GLITCHTIP_DSN !== 'false') {
    Sentry.init({dsn: REACT_APP_GLITCHTIP_DSN});
}

const element = document.getElementById('root') ?? document.body;
const root = createRoot(element);
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
